<template lang="pug">
div(class="d-flex flex-column flex-grow-1 min-h-0 tw-h-full fill-height overflow-hidden")
  div(class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left")
    v-row
      v-col(class="tw-capitalize")
        template(v-if="this.action !== 'add'")
          span(class=" tw-text-2xl text-secondary tw-font-bold ") {{ $t('Contacts.Common.editContact') }}
        template(v-else)
          span(class=" tw-text-2xl text-secondary tw-font-bold ") {{ $t('Contacts.Common.addContact') }}
  div(class=" tw-flex tw-h-full tw-flex-row tw-flex-grow tw-p-4 tw-pb-0 tw-pl-2 tw-overflow-hidden")
    v-form(ref="form" v-model="valid" lazy-validation @keyup.native.enter="valid && submit($event)" class="tw-w-full")
      v-row(align="start" justify="center" class="tw-pt-2")
        v-col(cols="11")
          v-row
            v-col
              v-text-field(v-model="contact.name" :label="$t('Common.name')" outlined hide-details)
            v-col
              v-text-field(v-model="contact.last_name" :label="$t('Contacts.Common.lastName')" outlined hide-details)
          v-row
            v-col
              v-text-field(v-model="contact.email" :label="$t('Common.email')" outlined hide-details)
            v-col
              v-text-field(v-model="contact.phone" :label="$t('Common.phone')" outlined hide-details)
          v-row
            v-col(class="tw-pt-0")
              gmap-autocomplete(v-model="address" class="IntroInput" selectFirstOnEnter @place_changed="setAddress")
                template(v-slot:input="slotProps")
                  v-text-field(
                    v-model="address"
                    :placeholder="$t('Contacts.Common.addressPlaceholder')"
                    ref="input"
                    hide-details
                    v-on:listeners="slotProps.listeners"
                    color="primary"
                  )
          v-row(dense)
            v-col(cols="9")
              v-text-field(
                v-model="contact.address_street"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.street')"
              )
            v-col(cols="3")
              v-text-field(
                v-model="contact.address_street_number"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.number')"
              )
          v-row(dense v-if="contact.address_extended_address")
            v-col
              v-text-field(
                v-model="contact.address_extended_address"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.extendedAddress')"
              )
          v-row(dense)
            v-col
              v-text-field(
                v-model="contact.addresss_block"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.block')"
              )
            v-col
              v-text-field(
                v-model="contact.address_floor"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.floor')"
              )
            v-col
              v-text-field(
                v-model="contact.address_door"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.door')"
              )
          v-row(dense)
            v-col
              v-text-field(
                v-model="contact.address_city"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.city')"
              )

            v-col
              v-text-field(
                v-model="contact.address_state"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.state')"
              )

          v-row(dense)
            v-col
              v-text-field(
                v-model="contact.address_country"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.country')"
              )

            v-col
              v-text-field(
                v-model="contact.address_zip_code"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.zipCode')"
              )

  div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1 ")
    v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
      v-col(cols="auto" align-end class="tw-h-full fill-height")
        v-btn(@click="cancel" text :ripple="false")
          span(class=" tw-text-kPurple tw-mt-4") {{ $t('Common.cancel') }}
        v-btn(depressed color="rgba(94,129,244,0.80)" :loading="loading" @click="submit")
          span(class="tw-font-bold") {{ $t('Common.save') }}
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      contact: {},
      valid: true,
      address: '',
    };
  },
  mounted() {
    if (this.action !== 'add') {
      return (this.contact = JSON.parse(JSON.stringify(this.$store.getters['contacts/current_contact'])));
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.action !== 'add') {
          this.$store
            .dispatch('contacts/updateContact', this.contact)
            .then((response) => {
              this.$emit('close');
              this.loading = false;
            })
            .catch((error) => {
              commit('SET_ERROR', error, { root: true });
            });
        } else {
          this.$store
            .dispatch('contacts/addContact', this.contact)
            .then((response) => {
              this.$emit('close');
              this.loading = false;
            })
            .catch((error) => {
              commit('SET_ERROR', error, { root: true });
            });
        }
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    setAddress(address) {
      this.contact.address_street = '';
      this.contact.address_street_number = '';
      this.contact.address_extended_address = '';
      this.contact.address_city = '';
      this.contact.address_state = '';
      this.contact.address_country = '';
      this.contact.address_zip_code = '';
      this.address = address.formatted_address;
      this.key += this.key;
      this.contact.address_latitude = address.geometry.location.lat();
      this.contact.address_longitude = address.geometry.location.lng();
      for (let i = 0; i < address.address_components.length; i++) {
        const componentType = address.address_components[i].types[0];
        switch (componentType) {
          case 'street_number':
            this.contact.address_street_number = address.address_components[i].long_name;
            break;

          case 'route':
            this.contact.address_street = address.address_components[i].long_name;
            break;

          case 'sublocality_level_1':
            this.contact.address_extended_address = address.address_components[i].long_name;
            break;

          case 'locality':
            this.contact.address_city = address.address_components[i].long_name;
            break;

          case 'administrative_area_level_1':
            this.contact.address_state = address.address_components[i].long_name;
            break;

          case 'country':
            this.contact.address_country = address.address_components[i].long_name;
            break;

          case 'postal_code':
            this.contact.address_zip_code = address.address_components[i].long_name;
            break;
        }
      }
    },
    cancel() {
      this.$emit('close');
    },
  },
};
</script>
